import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import "react-quill/dist/quill.snow.css"; // import styles
import * as Yup from "yup";

import useRequest from "../../hooks/useRequest";
import ImagePreview from "../../components/ImagePreview/ImagePreview";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import Select from "react-select";
import { ErrorMessage, Field, Form, Formik } from "formik";

const SendNotification = () => {
  const history = useHistory();

  const { response: responseUpdate, request: requestUpdate } = useRequest();
  const { request: requestCities, response: responseCities } = useRequest();
  const [touchedError, setTouchedError] = useState(false);
  const [displayImage, setDisplayImage] = useState();
  const [image, setImage] = useState();

  const [cities, setCities] = useState([]);
  const [city, setCity] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    control,
    clearErrors,
  } = useForm();

  useEffect(() => {
    requestCities("GET", "admin/vendor/getCity");
  }, []);

  useEffect(() => {
    if (responseCities) {
      if (responseCities.status && responseCities.data) {
        setCities(responseCities.data);
      }
    }
  }, [responseCities]);

  const onSubmit = (data) => {
    const { city, title, description, userType } = data;
    const formData = new FormData();
    formData.append("cityId", city);
    formData.append("topicNotification", title);
    formData.append("userType", userType);
    formData.append("messageNotification", description);

    if (displayImage) {
      if (data.image) {
        formData.append("image", data.image);
      }
    }

    requestUpdate("POST", "admin/user/sendBulkNotificationUser", formData);
  };

  useEffect(() => {
    if (responseUpdate) {
      if (responseUpdate.status && responseUpdate.message) {
        toast.success(responseUpdate?.message);
        history.push("/dashboard");
      }
    }
  }, [responseUpdate]);

  const handleImage = (event) => {
    event.preventDefault();
    if (event.target.files[0]) {
      setDisplayImage(URL.createObjectURL(event.target.files[0]));
      setError("image", "");
      setValue("image", event.target.files[0]);
    } else {
      setDisplayImage("");
      setImage("");
      setValue("image", "");
    }
  };

  const handleRemoveImage = () => {
    if (document.getElementById("image")) {
      document.getElementById("image").value = "";
    }
    setDisplayImage(null);
    setValue("image", null);
    setImage("");
  };
  const [description, setDescription] = useState(getValues("description"));

  const handleEditorChange = (e) => {
    setDescription(e.target.value);
    setValue("description");
  };
  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb
            title={"Add"}
            links={[
              { to: "/dashboard", name: "Home" },
              { to: "/notifications", name: "Notifications" },
            ]}
          />
        </div>
        <div className="col-xl-4 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Send Notification</h6>
            </div>
            <div className="ms-panel-body">
              <form
                className="needs-validation clearfix"
                noValidate
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="form-row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="city">
                      City<span className="field-required">*</span>
                    </label>
                    <Select
                      {...register("city", {
                        required: true,
                      })}
                      options={
                        cities &&
                        cities.length > 0 &&
                        cities.map((obj) => ({
                          label: obj.name,
                          value: obj._id,
                        }))
                      }
                      required={true}
                      name="cities"
                      onChange={(value) => {
                        setValue("city", value.value);
                        setCity(value.value);
                      }}
                    />
                    {errors.city && city == "" && (
                      <div
                        className="invalid-field"
                        style={{ position: "initial" }}
                      >
                        The City field is required.
                      </div>
                    )}
                  </div>
                  
                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <label htmlFor="userType">User Type</label>
                      <select
                        {...register("userType", {
                          required: true,
                        })}
                        required={true}
                        name="userType"
                        className="form-control"
                      >
                        <option value="">Select User Type</option>
                        <option value="user">User</option>
                        <option value="vendor">Vendor</option>
                      </select>
                    </div>

                    {errors?.userType && (
                      <div
                        className="invalid-field"
                        style={{ position: "initial" }}
                      >
                        The field is required.
                      </div>
                    )}
                  </div>

                  <div className="col-md-12 mb-3">
                    <label htmlFor="title">
                      Title<span className="field-required">*</span>
                    </label>
                    <div className="input-group">
                      <input
                        type="text"
                        id="title"
                        placeholder="Title"
                        className={`form-control ${
                          touchedError
                            ? errors.title
                              ? "is-invalid"
                              : "is-valid"
                            : ""
                        }`}
                        {...register("title", {
                          required: true,
                        })}
                      />
                      {errors.title?.type === "required" && (
                        <div className="invalid-field">
                          The title field is required.
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12 mb-3">
                    <label htmlFor="description">
                      Message<span className="field-required">*</span>
                    </label>
                    <div className="input-group mb-5">
                      {/* <CKEditor
                        {...register("description", {
                          required: true,
                        })}
                        initData={getValues("description")}
                        config={{
                          extraAllowedContent:
                            "p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*};i(*)[*]{*}",
                          allowedContent: true,
                          protectedSource: [/<i[^>]*><\/i>/g],
                          // removeEmpty: { i: false },
                        }}
                        onChange={({ editor }) => {
                          const data = editor.getData();
                          setValue("description", data);
                          clearErrors("description");
                        }}
                      /> */}

                      <textarea
                        id="description"
                        value={description} // Controlled by React state
                        name="description"
                        rows="5"
                        cols="30"
                        onChange={(e) => {
                          console.log("dddddd", e.target.value);
                          setDescription(e.target.value);
                          setValue("description", e.target.value);
                        }}
                        className={`form-control ${
                          touchedError
                            ? errors.description
                              ? "is-invalid"
                              : "is-valid"
                            : ""
                        }`}
                        {...register("description", { required: true })}
                      />

                      {errors.description?.type === "required" && (
                        <div className="invalid-field">
                          The description field is required.
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-12 mb-3">
                    <label htmlFor="image"> Image</label>
                    <div className="custom-file">
                      <Controller
                        control={control}
                        name="image"
                        render={({ field: { onChange, value, ref } }) => (
                          <input
                            type="file"
                            id="image"
                            onChange={handleImage}
                            style={{ display: "none" }}
                            inputRef={ref}
                            accept="image/*"
                            className="custom-file-input"
                          />
                        )}
                      />
                      <label className="custom-file-label" htmlFor="image">
                        Images
                      </label>
                      <div className="invalid-feedback">
                        Example invalid custom file feedback
                      </div>
                    </div>
                  </div>

                  <button
                    className="btn btn-primary mt-4 d-block w-100"
                    onClick={() => setTouchedError(true)}
                    type="submit"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Send Bulk SMS</h6>
            </div>
            <div className="ms-panel-body">
              <Formik
                initialValues={{
                  cityId: "",
                  userType: "",
                }}
                validationSchema={Yup.object({
                  cityId: Yup.string().required("City is required"),
                  userType: Yup.string().required("User Type is required"),
                })}
                onSubmit={(values, { resetForm }) => {
                  console.log("Form 1 Submitted", values);
                  requestUpdate("POST", "admin/bulkSmsSend", {
                    // numberArray: ["9549816159"],
                    ...values,
                  });

                  resetForm();
                }}
              >
                {({ setFieldValue, values }) => (
                  <Form className="needs-validation">
                    <div className="form-group">
                      <label htmlFor="cityId">City</label>

                      <Select
                        options={
                          cities &&
                          cities.length > 0 &&
                          cities.map((obj) => ({
                            label: obj.name,
                            value: obj._id,
                          }))
                        }
                        value={
                          values.cityId
                            ? cities.find((city) => city.id === values.cityId) // Find the selected object
                            : null
                        }
                        required={true}
                        name="cityId"
                        onChange={(value) => {
                          setFieldValue("cityId", value.value);
                        }}
                      />
                      <ErrorMessage
                        name="cityId"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="userType">User Type</label>
                      <Field
                        as="select"
                        name="userType"
                        className="form-control"
                      >
                        <option value="">Select User Type</option>
                        <option value="user">User</option>
                        <option value="vendor">Vendor</option>
                      </Field>
                      <ErrorMessage
                        name="userType"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary mt-3 w-100"
                    >
                      Send SMS
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
        {(displayImage || image) && (
          <div className="col-xl-4 col-md-12">
            <div className="row">
              <div className="col-md-12">
                <div className="ms-panel">
                  <div className="ms-panel-header">
                    <h6>Image </h6>
                  </div>
                  <div className="ms-panel-body">
                    <ImagePreview displayImage={displayImage} image={image} />
                  </div>

                  <div className="ms-panel-header ">
                    <label
                      className="btn btn-primary mx-2"
                      onClick={handleRemoveImage}
                    >
                      Remove
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="col-xl-4 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Send Bulk Email</h6>
            </div>
            <div className="ms-panel-body">
              <Formik
                initialValues={{
                  cityId: "",
                  userType: "",
                  msgType: "msgType",
                  emailContent: "",
                  emailSubject: "",
                }}
                validationSchema={Yup.object({
                  cityId: Yup.string().required("City is required"),
                  userType: Yup.string().required("User Type is required"),
                  emailContent: Yup.string().required(
                    "Email Content is required"
                  ),
                  emailSubject: Yup.string().required(
                    "Email Subject is required"
                  ),
                })}
                onSubmit={(values, { resetForm }) => {
                  console.log("Form 1 Submitted", values);
                  requestUpdate("POST", "admin/bulkSmsSend", {
                    // numberArray: ["9549816159"],
                    ...values,
                  });

                  resetForm();
                }}
              >
                {({ setFieldValue, values }) => (
                  <Form className="needs-validation">
                    <div className="form-group">
                      <label htmlFor="cityId">City</label>

                      <Select
                        options={
                          cities &&
                          cities.length > 0 &&
                          cities.map((obj) => ({
                            label: obj.name,
                            value: obj._id,
                          }))
                        }
                        value={
                          values.cityId
                            ? cities.find((city) => city.id === values.cityId) // Find the selected object
                            : null
                        }
                        required={true}
                        name="cityId"
                        onChange={(value) => {
                          setFieldValue("cityId", value.value);
                        }}
                      />
                      <ErrorMessage
                        name="cityId"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="userType">User Type</label>
                      <Field
                        as="select"
                        name="userType"
                        className="form-control"
                      >
                        <option value="">Select User Type</option>
                        <option value="user">User</option>
                        <option value="vendor">Vendor</option>
                      </Field>
                      <ErrorMessage
                        name="userType"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-12 mb-3">
                      <label htmlFor="description">
                        Email Subject<span className="field-required">*</span>
                      </label>
                      <div className="input-group ">
                        <textarea
                          id="emailSubject"
                          value={values?.emailSubject} // Controlled by React state
                          name="emailSubject"
                          rows="5"
                          cols="30"
                          onChange={(e) => {
                            setFieldValue("emailSubject", e.target.value);
                          }}
                          className={`form-control ${
                            touchedError
                              ? errors.emailSubject
                                ? "is-invalid"
                                : "is-valid"
                              : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="emailSubject"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-12 mb-3">
                      <label htmlFor="description">
                        Email Content<span className="field-required">*</span>
                      </label>
                      <div className="input-group">
                        <textarea
                          id="emailContent"
                          value={values?.emailContent} // Controlled by React state
                          name="emailContent"
                          rows="5"
                          cols="30"
                          onChange={(e) => {
                            setFieldValue("emailContent", e.target.value);
                          }}
                          className={`form-control ${
                            touchedError
                              ? errors.emailContent
                                ? "is-invalid"
                                : "is-valid"
                              : ""
                          }`}
                        />
                      </div>
                    </div>
                    <ErrorMessage
                      name="emailContent"
                      component="div"
                      className="text-danger"
                    />

                    <button
                      type="submit"
                      className="btn btn-primary mt-3 w-100"
                    >
                      Send SMS
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendNotification;
